export const isExternalPath = (href?: string) =>
  href?.startsWith("http") || href?.startsWith("mailto:");
